import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  clicked() {
    this.element.innerText = "You clicked me!"
  }
}